import { render, staticRenderFns } from "./FileExcelIcon.vue?vue&type=template&id=6a1a7626&"
import script from "./FileExcelIcon.vue?vue&type=script&lang=js&"
export * from "./FileExcelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports